import React from "react";
import { TFunction } from "i18next";
import { CustomButton } from "../../../../atoms/CustomButton";
import { ModalShell } from "../../../../atoms/ModalShell";

type AccessRestrictedModalProps = {
  show: boolean;
  onClose: () => void;
  onUpgrade: () => void;
  t: TFunction;
};

const AccessRestrictedModal: React.FC<AccessRestrictedModalProps> = ({
  show,
  onClose,
  onUpgrade,
  t,
}) => {
  return (
    <ModalShell
      show={show}
      onClose={onClose}
      size="lg"
      title={t("dashboard.entities.viewEntityUser.sendMsg.accessRestricted")}
      subtitle={t("dashboard.entities.viewEntityUser.sendMsg.upgradeRequired")}
      footer={
        <>
          <CustomButton
            variant="secondary"
            onClick={onClose}
            title={t("common.cancel") as string}
          />
          <CustomButton
            variant="primary"
            onClick={onUpgrade}
            title={
              t(
                "dashboard.entities.viewEntityUser.sendMsg.upgradeNow"
              ) as string
            }
          />
        </>
      }
    >
      <div className="text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <svg
            className="h-8 w-8 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>

        <h3 className="mb-4 text-lg font-semibold text-gray-900">
          {t("dashboard.entities.viewEntityUser.sendMsg.premiumFeatureTitle")}
        </h3>

        <p className="mx-auto mb-6 max-w-md text-gray-600">
          {t("dashboard.entities.viewEntityUser.sendMsg.messagingFeatureDesc")}
        </p>

        <div className="mb-6 rounded-lg border border-blue-200 bg-blue-50 p-4">
          <h4 className="mb-2 font-semibold text-blue-800">
            {t("dashboard.entities.viewEntityUser.sendMsg.messagingBenefits")}
          </h4>
          <ul className="space-y-1 text-sm text-blue-700">
            <li>• {t("dashboard.entities.viewEntityUser.sendMsg.benefit1")}</li>
            <li>• {t("dashboard.entities.viewEntityUser.sendMsg.benefit2")}</li>
            <li>• {t("dashboard.entities.viewEntityUser.sendMsg.benefit3")}</li>
            <li>• {t("dashboard.entities.viewEntityUser.sendMsg.benefit4")}</li>
            <li>• {t("dashboard.entities.viewEntityUser.sendMsg.benefit5")}</li>
          </ul>
        </div>
      </div>
    </ModalShell>
  );
};

export default AccessRestrictedModal;
